export default "__VITE_ASSET__DPen7Zju__"